const composeCategoryPageParams = (
  pageNr: number | undefined,
  sortBy: string | undefined,
  filters: any | undefined,
  query?: string,
) => {
  const params: string[] = [];
  if (pageNr) {
    params.push(`pageNr=${pageNr}`);
  }
  if (sortBy) {
    params.push(`sortBy=${sortBy}`);
  }
  if (query) {
    params.push(`query=${query}`);
  }
  if (filters) {
    Object.keys(filters).forEach((filterType) => {
      filters[filterType].forEach((filterCondition: any) => {
        const key = filterCondition.typeName;
        const values = filterCondition.values as string[];
        values.forEach((value) => {
          params.push(`${key}[]=${value}`);
        });
      });
    });
  }
  return params.length ? `?${params.join('&')}` : undefined;
};

export default composeCategoryPageParams;
